import { GetPageAnalyticsQueryVariables, useGetPageAnalyticsQuery } from 'data/generated/graphql';
import { useConvertedProperty } from 'hooks/useConvertedProperty';

export const usePageAnalytics = (variables: GetPageAnalyticsQueryVariables) => {
  const currentProperty = useConvertedProperty();

  return useGetPageAnalyticsQuery(variables, {
    enabled: !!currentProperty,
    staleTime: 60000
  });
};
